import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FormsModule } from "@angular/forms";
import { Choice } from "../../../../polls/polls.type";
import { QuestionForPreview } from "app/frontend/lib/polls/create-poll/create-poll.type";

@Component({
    selector: "agree-disagree-question",
    templateUrl: "./agree-disagree-question.component.html",
    styleUrls: [".././poll-request.component.scss", "./agree-disagree-question.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatTooltipModule
    ]
})
export class AgreeDisagreeQuestionComponent implements OnChanges {
    
    protected userAnswerId: string;
    protected possibleAnswers: Choice[];
    protected possibleAnswersReverse: Choice[];
    
    @Input() question: QuestionForPreview;

    @Output() onAnswerChange = new EventEmitter<any>();

    constructor(){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.question.currentValue){
            this.possibleAnswers = this.question.choices.sort((a, b) => a.position - b.position);
            const possibleAnswersCopy = [...this.possibleAnswers]
            this.possibleAnswersReverse = possibleAnswersCopy.sort((a, b) => b.position - a.position);
            this.userAnswerId = undefined;
        }
    }

    changeAnswer(id: string){
        this.userAnswerId = id;
        this.onAnswerChange.emit(id);
    }

}